<template>
  <div v-if="branch?.address" class="product-address">
    <product-address />
    <content-viewer
      v-if="isViewAllShown"
      :title="$t('booking_detail.address')"
      :is-full-height="true"
      :is-footer-shown="false"
      :is-fallback-shown="true"
      main-content-class="px-0 py-4"
    >
      <template #trigger="{ open }">
        <product-view-all-button @view-all-click="open" />
      </template>
      <product-address class="px-5" />
      <template v-for="section in viewerSections" :key="section.id">
        <div v-if="section.list.length" class="border-t border-gray-40">
          <p class="px-5 py-4">{{ section.title }}</p>
          <bullet-text class="p-5" :content="section.list" />
        </div>
      </template>
    </content-viewer>
  </div>
</template>

<script lang="ts" setup>
import ContentViewer from '@/components/common/content-viewer.vue'
import BulletText from '@/components/common/bullet-text.vue'
import ProductAddress from '@/components/product/product-detail/product-address.vue'
import ProductViewAllButton from '@/components/product/product-detail/product-view-all-button.vue'

const { t } = useI18n()

const { branch } = useBranchDetailContext()

const isViewAllShown = computed(() => !!branch.value?.transportation || !!branch.value?.nearby_spot)
const viewerSections = computed(() => [
  {
    id: 'public-transportation',
    title: t('branch_detail.about.public_transportation'),
    list: branch.value?.transportation ? branch.value.transportation.split('\n') : [],
  },
  {
    id: 'nearby-attractions',
    title: t('branch_detail.about.nearby_attractions'),
    list: branch.value?.nearby_spot ? branch.value.nearby_spot.split('\n') : [],
  },
])
</script>
